// @flow
import React, { Fragment } from 'react';
import PropTypes from "prop-types";
import { Helmet } from 'react-helmet';
import coverImg from '../../../assets/img/meta-cover-lightblue.png';
import environment from '../../../environment';
import { defineMessages, intlShape } from 'react-intl';

import style from './PrivacyPolicy.scss';

import type { LocaleState } from '../../locale/duck';
import type { Context } from 'koa';

type Props = {
  +locale: LocaleState;
};

const messages = defineMessages({
  US: {
    title: {
      id: 'privacy.title.US',
    },
    description: {
      id: 'privacy.description.US',
    },
    titleOg: {
      id: 'privacy.title.og.US',
    },
    descriptionOg: {
      id: 'privacy.description.og.US',
    },
  },
  PE: {
    title: {
      id: 'privacy.title.PE',
    },
    description: {
      id: 'privacy.description.PE',
    },
    titleOg: {
      id: 'privacy.title.og.PE',
    },
    descriptionOg: {
      id: 'privacy.description.og.PE',
    },
  },
  CO: {
    title: {
      id: 'privacy.title.CO',
    },
    description: {
      id: 'privacy.description.CO',
    },
    titleOg: {
      id: 'privacy.title.og.CO',
    },
    descriptionOg: {
      id: 'privacy.description.og.CO',
    },
  },
  default: {
    title: {
      id: 'privacy.title',
    },
    description: {
      id: 'privacy.description',
    },
    titleOg: {
      id: 'privacy.title.og',
    },
    descriptionOg: {
      id: 'privacy.description.og',
    },
  },
});

const pypES = <section className={style.privacyPolicyWrap}>
  <h1>
    POLÍTICA DE PRIVACIDAD Y DE PROTECCIÓN DE DATOS PERSONALES
  </h1>
  <p>
    La presente Política de Privacidad y de Protección de Datos Personales (en
    adelante, la <strong>"Política de Privacidad"</strong>) regula la remisión de datos
    personales que efectúan los usuarios mediante el portal de Internet
    denominado Qempo, ubicado en el Identificador Uniforme de Recursos (en
    adelante, el <strong>"URL"</strong>) <a href="http://www.qempo.com"
                                            target="_blank">http://www.qempo.com</a> (en adelante,
    el <strong>"Portal"</strong>) que Qempo LLC
    (en adelante,
    <strong>"Qempo"</strong>) pone a
    disposición de sus usuarios.
  </p>
  <br/>
  <p>
    Su registro, acceso y/o uso del contenido y/o de los servicios provistos
    por medio del Portal atribuyen a usted la condición de usuario del Portal
    (en adelante, <strong>"Usuario"</strong>, y encontrándose comprendido en las
    expresiones singular <strong>"Usuario"</strong> y <strong>"Usted"</strong>, y en la
    plural <strong>"Usuarios"</strong>) e implica que usted
    acepta, plenamente y sin reservas,
    todas y cada una de las disposiciones contenidas en estos Términos y
    Condiciones, en la versión publicada por Qempo en el momento mismo en que
    Usted acceda al Portal para registrarse, acceder y/o usar cualquiera de sus
    contenidos y/o servicios. En consecuencia, usted declara reconocer y
    aceptar que se encuentra obligado a leer completamente los presentes
    Términos y Condiciones en cada una de las ocasiones en que se proponga
    acceder y/o utilizar los contenidos y/o servicios dispuestos en el Portal,
    ya que pueden ser objeto de modificaciones a sola discreción de Qempo, y
    sin necesidad de notificación previa ni adicional a la sola publicación en
    el Portal. Los términos en mayúsculas que no se encuentren expresamente
    definidos en la presente Política de Privacidad tendrán las definiciones
    contenidas en los Términos y Condiciones Generales del Portal.
  </p>
  <br/>
  <p>
    <strong>
      SI USTED NO ESTÁ DE ACUERDO CON LOS PRESENTES TÉRMINOS Y CONDICIONES,
      LOS CUALES TIENEN UN CARÁCTER OBLIGATORIO Y VINCULANTE PARA USTED,
      DEBERÁ DETENER SU PROCESO DE REGISTRO EN EL PORTAL O, DE YA HABERLO
      REALIZADO, ABSTENERSE DE ACCEDER O UTILIZAR EL MISMO, SUS CONTENIDOS
      Y/O SERVICIOS.
    </strong>
  </p>
  <br/>
  <p>
    La presente Política de Privacidad y Protección de Datos Personales regula
    el tratamiento de datos personales que Qempo obtiene de sus Usuarios
    registrados a través del Portal, datos que son registrados, almacenados y
    asociados en bancos de datos personales de titularidad de Qempo, los cuales
    contienen información de diversas fuentes.
  </p>
  <br/>
  <p>
    El Usuario declara que los datos personales y la información que
    proporciona a Qempo son veraces, exactos y actualizados, y será el único
    responsable de informar a Qempo, por los canales establecidos por este
    último, para solicitar la debida actualización de los datos personales y la
    información del Usuario, según corresponda. Cualquier controversia,
    situación adversa y/o problema que pudiesen ser originados por el
    incumplimiento de la actualización de los datos personales y/o de la
    información provistos por el Usuario, serán de exclusiva responsabilidad de
    este último.
  </p>
  <br/>
  <p>
    La información personal del Usuario se procesa y almacena en servidores y/o
    medios magnéticos que mantienen altos estándares de seguridad y protección,
    tanto física como tecnológica, y con la misma diligencia que con la cual
    Qempo procesa y almacena su propia información.
  </p>
  <br/>
  <p>
    Usted autoriza a Qempo al almacenamiento en bancos de datos y al tratamiento
    de toda la información y de los datos personales, incluida su imagen, enviados
    por el Usuario a Qempo ya sea directamente o a través de otras cuentas utilizadas
    para el registro, a Usuarios, a Compradores y a Viajeros, por cualquier medio del
    Portal, incluyendo, mas no limitándose al historial de conversaciones sostenidas
    a través del Portal, entre otros. Usted autoriza expresamente a Qempo el tratamiento
    de sus datos personales y, en general, de todos los datos personales que Usted remita
    y/o ponga a disposición de Qempo mediante su acceso uso y/o registro en el Portal,
    para los fines que Qempo considere convenientes, entre los que se encuentran,
    el envío al Usuario de publicidad sobre Qempo, la transferencia de los datos
    personales para su uso a empresas del mismo grupo, y/o utilizarla como publicidad
    de la plataforma de Qempo, para mejorar nuestros servicios y ofrecerte nuevos
    productos y servicios personalizados.
  </p>
  <br/>
  <p>
    El Usuario declara reconocer y aceptar que Qempo no será responsable por el
    acceso y/o por la divulgación de información personal del Usuario originada
    en el acceso no autorizado al banco de datos de Qempo y/o al Portal,
    incluyendo mas no limitándose a las efectuadas mediante actos de intrusión
    informática.
  </p>
  <br/>
  <p>
    El Usuario autoriza a Qempo a brindar acceso y/o transferir sus datos
    personales a personas vinculadas que formen parte del grupo empresarial de
    Qempo, en el marco de lo establecido en los presentes Términos y
    Condiciones. Asimismo, el Usuario autoriza a Qempo a realizar la
    transferencia nacional e internacional de sus datos personales a terceros,
    sin restricción ni limitación alguna.
  </p>
  <br/>
  <p>
    El Usuario, por el simple hecho de registrarse, acceder y/o utilizar el
    Portal y/o el Servicio, acepta que Qempo le envíe toda clase de mensajes,
    anuncios y/o publicidad (incluyendo mas no limitándose a correos
    electrónicos comerciales, folletos, cartas, encuestas, etc.) a su dirección
    física y/o virtual declarada, con las novedades, noticias y/o promociones
    del Servicio, así como de productos o servicios ofrecidos por terceros
    anunciantes.
  </p>
  <br/>
  <p>
    El Usuario declara reconocer y aceptar que, ante eventuales órdenes
    jurisdiccionales y/o administrativas, Qempo puede verse obligado a revelar
    datos personales, comunicaciones e información personal de un Usuario en
    particular a las autoridades y/o a terceras personas bajo ciertas
    circunstancias, en cuyo caso el Usuario exime expresamente de
    responsabilidad a Qempo por la revelación de dicha información ante la
    exigencia de una autoridad competente, o cuando menos aparentemente
    competente.
  </p>
  <br/>
  <p>
    El Usuario autoriza a Qempo a conservar sus datos personales una vez se dé
    de baja el Portal, para el cumplimiento de las obligaciones legales
    pertinentes. Asimismo, el Usuario autoriza a Qempo a enviarle correos
    electrónicos comerciales a la dirección electrónica vinculada con su perfil
    de Usuario en el Portal, pudiendo incluir ofertas de productos y servicios
    de Qempo, así como también de sus socios comerciales y de anunciantes que
    deseen ofrecer productos y/o servicios a los Usuarios.
  </p>
  <br/>
  <p>
    Qempo se reserva el derecho a modificar la presente política en cualquier
    momento, sin previo aviso ni expresión de causa. El Usuario declara aceptar
    la versión más reciente de los presentes Términos y Condiciones mediante su
    acceso al Portal.
  </p>
  <br/>
  <p>
    Los Usuarios, los Compradores y los Viajeros declaran reconocer y aceptar
    que Qempo no será responsable por el uso inapropiado de los datos
    personales que los Usuarios, los Compradores y/o los Viajeros intercambien
    mediante el Portal.
  </p>
  <br/>
  <p>
    El Usuario podrá solicitar a Qempo el ejercicio de sus derechos de
    protección de datos personales, tales como los de actualización,
    rectificación, cancelación y oposición, lo cual realizará enviando una
    comunicación al correo electrónico <u><a href="mailto:arco@qempo.com">arco@qempo.com</a></u>.
  </p>
  <br/>
  <p>
    El Usuario declara reconocer y aceptar que, durante su acceso, uso y/o
    registro en el Portal, el Usuario tendrá la posibilidad de instalar una
    extensión de Qempo en su navegador con la finalidad de la integración de
    ciertos servicios de Qempo en la interfaz de navegación del Usuario.
    Asimismo, Qempo tendrá la posibilidad de almacenar ‘cookies’, los cuales
    consisten en pequeños archivos informáticos que son descargados mediante la
    Internet en los dispositivos informáticos de los Usuarios con la finalidad
    de que Qempo reciba y mantenga información actualizada sobre el
    identificador del usuario, el número de sesión, los datos de navegación del
    Usuario, las características del hardware y el software del dispositivo
    desde el cual el Usuario accede al Portal, el idioma, la ubicación
    geográfica en la cual se encuentra el Usuario, su número de IP, su última
    fecha de conexión, entre otros datos.
  </p>
  <h2>
    MODIFICACIÓN
  </h2>
  <p>
    Qempo se reserva el derecho a modificar la presente Política de Privacidad
    en cualquier momento y sin previo aviso, los cuales el Usuario declara
    haber leído y aceptado en su integridad como condición previa cada vez que
    acceda al Portal y/o a la prestación del Servicio del Viajero.
  </p>
  <h2>
    DURACIÓN Y TERMINACIÓN
  </h2>
  <p>
    El Portal tiene, en principio, una duración indefinida. Qempo, no obstante
    ello, podrá suspender y/o dar de baja unilateralmente al Portal y/o al
    Servicio, en cualquier momento, sin expresión de causa y sin que ello pueda
    originar contraprestación, penalidad ni indemnización alguna a favor suyo
    y/o a favor de cualquier Usuario, Comprador y/o Viajero. Cuando ello sea
    razonablemente posible, Qempo advertirá previamente al Usuario sobre la
    suspensión o baja del Portal y/o del Servicio.
  </p>
  <h2>
    LEGISLACIÓN Y JURISDICCION APLICABLE
  </h2>
  <p>
    Los presentes Términos y Condiciones se rigen, en todo lo no dispuesto en
    el presente documento, por las normas legales aplicables del Estado de
    Florida, Estados Unidos de América. Qempo y Usted renuncian expresamente a
    cualquier otro fuero y/o jurisdicción que pudiese corresponderle.
  </p>
  <h2>
    GENERALIDADES
  </h2>
  <p>
    En el caso de que cualquier disposición o disposiciones de los Términos y
    Condiciones fuesen considerados total o parcialmente nulos e/o
    inaplicables, por cualquier juzgado, tribunal y/u órgano administrativo
    competente, dicha nulidad o inaplicación no afectará a las otras
    disposiciones no declaradas nulas e/o inaplicables específicamente.
  </p>
  <h2>
    CONTACTO
  </h2>
  <p>
    Para cualquier contacto con Qempo, el Usuario deberá comunicarse al correo
    electrónico: <a href="mailto:hola@qempo.com">hola@qempo.com</a>.
  </p>
  <br/>
  <h2>SOLICITUD DE ELIMINACIÓN DE DATOS</h2>
  <p>
    Todo usuario que desee solicitar la eliminación de sus datos de la “Base de datos” de Qempo, debe hacerlo
    formalmente a través de una solicitud a hola@qempo.com solicitando la eliminación de todos sus datos. Qempo
    verificará la solicitud y de cumplir todas las normas, procederá a eliminar sus datos sin ninguna objeción.
  </p>
  <br/>
  <section>
    <p>
      Política de Privacidad y de Protección de Datos Personales versión 1.0
      vigente desde el día
    </p>
    <br/>
    <p>
      25 de Octubre del 2018.
    </p>
    <br/>
    <p>
      <strong>QEMPO.COM</strong> es un portal administrado por <em>QEMPO LLC</em>
    </p>
    <p>
      © QEMPO LLC – Todos los derechos reservados
    </p>
  </section>
</section>;
const pypEN = <section className={style.privacyPolicyWrap}>
  <h1>PRIVACY AND PERSONAL DATA PROTECTION POLICY</h1>
  <p>This Privacy and Personal Data Protection Policy (hereinafter, the <strong>"Privacy Policy"</strong>) governs the
    personal data submission made by users of the website named Qempo, located at the Uniform
    Resource Locator (hereinafter, the <strong>"URL"</strong>) <a href="http://www.qempo.com"
                                                                  target="_blank">http://www.qempo.com</a> (hereinafter,
    the <strong>"Website"</strong>) which Qempo LLC (hereinafter, <strong>"Qempo"</strong>) makes available to its
    users.
  </p>
  <br/>
  <p>Your sign-up, access and/or use of the contents and/or the services rendered by the Website grant you the user
    condition of the Website (hereinafter, <strong>“User”</strong>, and it includes the
    terms <strong>“User”</strong> and <strong>“You”</strong> in singular and the term <strong>“Users”</strong> in
    plural) and involves that you wholly accept without limitation any and all provisions set forth in
    these Terms and Conditions in the version posted by Qempo when You access to the Website to sign-up, access and/or
    use its contents and/or services.</p><p>Therefore, you represent to acknowledge and accept that you undertake to
  read fully these Terms and Conditions every time where the contents and/or the services of the Website are proposed
  to be accessed and/or used and these Terms and Conditions may be subject to any amendment upon Qempo sole discretion
  without requiring a prior notice upon it is posted in the Website.</p><p>Capitalized terms which are not expressly
  defined in this Privacy Policy shall have the definitions stated under the General Terms and Conditions of the
  Website.</p>
  <br/>
  <p><strong>IF YOU DISAGREE WITH THESE TERMS AND CONDITIONS WHICH ARE MANDATORY AND BINDING FOR YOU, YOU SHALL STOP
    YOUR
    SIGN-IN PROCESS IN THE WEBSITE OR, IF YOU HAVE ALREADY MADE IT, YOU SHALL PREVENT FROM ACCESSING OR USING THEREOF,
    ITS CONTENTS AND/OR ITS SERVICES.</strong></p>
  <br/>
  <p>
    This Privacy and Personal Data Protection Policy governs personal data use
    provided by Qempo from their signed-up Users by the Website. These data are
    recorded, stored and linked in personal databases owned by Qempo, which
    have information from different sources.
  </p>
  <br/>
  <p>
    User represents that personal data and information provided to Qempo are
    true, accurate and updated and User shall be solely liable for advising
    Qempo by channels stated by the latter to request duly updating for User
    personal data and information, as the case may be. Any controversy,
    conflict and/or problem arising from breaching personal data and/or
    information updating provided by User, shall be solely borne by User.
  </p>
  <br/>
  <p>
    User personal information is processed and stored in servers and/or
    magnetic means with high safety and protection standards not only physical,
    but also technological, and with the same diligence used by Qempo to
    process and store its own information.
  </p>
  <br/>
  <p>
    You authorize Qempo to store in databases and use all information and
    personal data submitted by User to Qempo, Users, Purchasers and Travelers,
    by any means of the Website, including without limitation the history of
    conversations made by the Website. You expressly authorize Qempo to use
    your personal data, and, in general, all your personal data submitted
    and/or made available to Qempo by your access, use and/or sign-up in the
    Website.
  </p>
  <br/>
  <p>
    User represents to acknowledge and accept that Qempo shall not be liable
    for accessing and/or disclosing User personal information arising from
    non-authorized access to Qempo and/or Website database including without
    limitation those made by computer intrusion acts.
  </p>
  <br/>
  <p>
    User authorizes Qempo to provide access and/or transfer his personal data
    to related persons composing Qempo corporate group under the provisions of
    these Terms and Conditions. Furthermore, User authorizes Qempo to make
    local or international transfer of his personal data to third parties,
    without any restriction nor limitation.
  </p>
  <br/>
  <p>
    By signing-up, accessing and/or using the Website and/or the Service, User
    accepts that Qempo submits User all kind of messages, ads and/or
    advertisement (including without limitation business emails, brochures,
    letters, surveys, and so on) to his stated physical and/or internet address
    with the newness, news and/or promotions of the Services, as well as the
    products and/or the services offered by third party advertisers.
  </p>
  <br/>
  <p>
    User represents to acknowledge and accept that, when court and/or
    administrative orders are issued, Qempo may be compelled to disclose
    personal data, communication and personal information from a User,
    specially, to authorities and/or third parties under some circumstances,
    and in this case, User expressly holds Qempo harmless from disclosing this
    information when it is required by a competent authority or, at least, an
    allegedly competent authority.
  </p>
  <br/>
  <p>
    User authorizes Qempo to keep his personal data when the Website is
    cancelled to comply with the corresponding legal obligations. Furthermore,
    User authorizes Qempo to send business emails to email related to his User
    profile in the Website, which may include Qempo product and service offers
    as well as product and service offers from its business partners and
    advertisers willing to offer products and/or services to Users.
  </p>
  <br/>
  <p>
    Qempo reserves the right to amend this policy at any time, without prior
    notice and without cause. User represents to accept the most recent version
    of these Terms and Conditions by accessing the Website.
  </p>
  <br/>
  <p>
    Users, Purchasers and Travelers represent to acknowledge and accept that
    Qempo shall not be liable for undue use of personal data exchanged by
    Users, Purchasers and Travelers using the Website.
  </p>
  <br/>
  <p>
    User may request Qempo to exercise his personal data protection rights such
    as updating, amending, cancelling and opposing rights, which shall be made
    by submitting an email to <a href="mailto:arco@qempo.com">arco@qempo.com</a>.
  </p>
  <br/>
  <p>
    User represents to acknowledge and accept that, during his access, use
    and/or sign-up in the Website, User may install a Qempo extension in his
    browser to integrate those Qempo services in User browser interface.
    Furthermore, Qempo may store ‘cookies’, which are small computer files
    unloaded by Internet in computer devices from Users so that Qempo receives
    and keeps updated information on user id, session number, User browser
    data, hardware and software features of device whereby User enters to the
    Website, language, geographical location where User is located, his IP
    number, his last connection date, among other data.
  </p>
  <br/>
  <h2>AMENDMENT</h2>
  <p>
    Qempo reserves the right to amend this Privacy Policy at any time without
    further notice which User represents to have wholly read and accepted as
    prior condition when he accesses to the Website and/or the rendering of the
    Traveler Service.
  </p>
  <br/>
  <h2>TERM AND TERMINATION </h2>
  <p>
    At the beginning, the Website has an indefinite term. Notwithstanding the
    foregoing, Qempo may suspend and/or cancel unilaterally the Website and/or
    the Service, at any time, without cause and this may not cause any
    consideration, penalty nor compensation to be paid in favor of Qempo and/or
    of any User, Purchaser and/or Traveler. When it is reasonably possible,
    Qempo shall warn User in advance on the Website and/or the Service
    suspension or cancellation.
  </p>
  <br/>
  <h2>APPLICABLE LAW AND JURISDICTION </h2>
  <p>
    For every matter which is not set forth herein, these Terms and Conditions
    are governed by applicable legal rules of Florida State, United States of
    America. Qempo and You expressly waive to any other venue and/or
    jurisdiction, which may be competent.
  </p>
  <br/>
  <h2>GENERAL PROVISIONS</h2>
  <p>
    If any provision or provisions of the Terms and Conditions are held wholly
    or in part null and/or unenforceable by any competent court, tribunal
    and/or administrative body, this nullity or unenforceability shall not
    affect other provisions not deemed specifically null and/or unenforceable.
  </p>
  <br/>
  <h2>CONTACT</h2>
  <p>
    To contact Qempo, User shall send an email to <a href="mailto:hola@qempo.com">hola@qempo.com</a>.
  </p>
  <br/>
  <h2>REQUEST DATA DELETION</h2>
  <p>
    Any user who want to request the elimination of their personal information from the Qempo "Database", must do so
    formally through a request to hola@qempo.com requesting the elimination of all their data. Qempo will verify the
    request and comply with all the rules, will proceed to delete your data without any objection.
  </p>
  <br/>
  <section>
    <p>
      Version 1.0 of Privacy and Personal Data Protection Policy in force as of
    </p>
    <p>
      October 25, 2018.
    </p>
    <br/>
    <p>
      <strong>QEMPO.COM</strong> is a website managed by <em>QEMPO LLC</em>
    </p>
    <p>
      © QEMPO LLC –All rights reserved
    </p>
  </section>
</section>;

const PrivacyPolicy = (props: Props, context: Context) => {
  const { locale } = props;
  let content = pypES;
  if (props.locale.locale === 'en') {
    content = pypEN;
  }
  const title = context.intl.formatMessage((messages[locale.domainCountry] || messages.default).title);
  const titleOg = context.intl.formatMessage((messages[locale.domainCountry] || messages.default).titleOg);
  const description = context.intl.formatMessage((messages[locale.domainCountry] || messages.default).description);
  const descriptionOg = context.intl.formatMessage((messages[locale.domainCountry] || messages.default).descriptionOg);
  const baseUrl = environment.baseUrl[locale.domainCountry || 'US'];
  return <Fragment>
    <Helmet meta={[
      { name: 'description', content: description },
      { property: 'og:image', content: `${baseUrl}${coverImg}` },
      { property: 'og:title', content: titleOg },
      { property: 'og:description', content: descriptionOg },
      { name: 'twitter:title', content: title },
      { name: 'twitter:twitter:image', content: `${baseUrl}${coverImg}` },
      { name: 'twitter:twitter:description', content: description },
    ]}>
      <title>{title}</title>
    </Helmet>
    {content}
  </Fragment>
};

PrivacyPolicy.propTypes = {
  locale: PropTypes.object,
};

PrivacyPolicy.contextTypes = {
  intl: intlShape,
};

export default PrivacyPolicy;



// WEBPACK FOOTER //
// ./src/modules/privacy-policy/components/PrivacyPolicy.jsx